import { BlockedIssuersProps, DefaultBlockedIssuersState, InstallmentsPlans } from "./types";

const installmentsFormInfo = {
  title: "Configuración de cuotas y medios de pago",
  subtitle: "Seleccioná los planes de cuotas y medios de pago que deseas ofrecer a tus clientes a la hora de pagar con MODO",
  installmentsDescription: {
    title: "Planes de cuotas",
    firstDesciption: {
      text: "Elegí las cuotas que tus clientes verán al pagar con MODO. Recordá que en las cuotas sin interés vos absorbés el costo financiero. ",
      link: {
        text: "¿Cuáles son los costos financieros?",
        href: "https://ayuda.payway.com.ar/cobros/cuotas/planes-payway"
      }
    },
    secondDesciption: {
      text: "Para ofrecer los programas \"Cuotas MiPyME\" primero deberás habilitarlos en Payway. ",
      link: {
        text: "¿Cómo los habilito?",
        href: "https://ayuda.payway.com.ar/cobros/planes-ahora"
      }
    },
  },
  paymentIssuersTitle: "Bloqueo de medios de pago",
  paymentIssuersDescription: "<p>Seleccioná los medios de pago que <b>NO</b> deseas ofrecerle a tus clientes. VISA y MASTERCARD siempre estarán habilitados.</p>"
};

const setDefaultInstallmentsValues = (installmentsPlans: InstallmentsPlans) => {
  const defaultValues = {};

  for (const [installment, plan] of Object.entries(installmentsPlans)) {
    if (plan) {
      const planType = (() => {
        if (plan.tem === null && plan.tna === null && plan.coefficient === null) {
          if (plan.planAhora) {
            return {label: `${installment} cuotas MiPyME CON interés`, value: "SIMPLE_WITH_INT"};
          }
          return {label: `${installment} cuotas CON interés`, value: "TRAD_WITH_INT"};
        } else if (plan.tem === 0 && plan.tna === 0 && plan.coefficient === 1) {
          if (plan.planAhora) {
            return {label: `${installment} cuotas MiPyME SIN interés`, value: "SIMPLE_WITHOUT_INT"};
          }
          return {label: `${installment} cuotas SIN interés`, value: "TRAD_WITHOUT_INT"};
        } else {
          return undefined;
        }
      })();
      defaultValues[installment] = planType;
    }
  }
  return defaultValues;
};

const setDefaultBlockedIssuersValues = (issuersResponse: BlockedIssuersProps | null, issuersState: DefaultBlockedIssuersState) => {  
  if (issuersResponse?.issuer_name) {
    switch (issuersResponse.issuer_name.type) {
      case "block":
        issuersResponse.issuer_name.value.forEach((item) =>
          Object.defineProperty(issuersState, item, {
            value: true,
          })
        );
        break;
      case "allow":
        issuersResponse.issuer_name.value.forEach((item) => {
          for (const clave in issuersState){
           issuersState[clave] = true;
          }
          Object.defineProperty(issuersState, item, {
            value: false,
          });
        }
      );
        break;
      default:
        return issuersState;
    }
  }

  return issuersState;
};


export {
  setDefaultInstallmentsValues,
  installmentsFormInfo,
  setDefaultBlockedIssuersValues
};